import React from 'react';
import PropTypes from 'prop-types';

import { withSubscription } from '@spotahome/soyuz-mediator';

import { OPEN_FAVORITE_CLAIM } from '../channels';

import withModalHandle from './withModalHandle';
import LoginModal from './login/LoginModal';

const modalEvents = {
  open: {
    eventCategory: 'signup/login modal',
    eventAction: 'FavoriteClaim',
    eventLabel: 'open'
  },
  close: {
    eventCategory: 'signup/login modal',
    eventAction: 'FavoriteClaim',
    eventLabel: 'close'
  }
};

const LoginModalSubscribedToFavoriteClaim = withSubscription({
  channelName: OPEN_FAVORITE_CLAIM
})(props => (
  <LoginModal
    initialAction="signup"
    isOpen={props.isOpen}
    onClose={props.onClose}
  />
));

LoginModalSubscribedToFavoriteClaim.propTypes = {
  onEvent: PropTypes.func.isRequired,
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired
};

const FavoriteClaimLoginModal = withModalHandle(modalEvents)(props => (
  <LoginModalSubscribedToFavoriteClaim
    isOpen={props.isModalOpen}
    onClose={props.handleModalClose}
    onEvent={props.handleModalOpen}
  />
));

export default FavoriteClaimLoginModal;
